import React from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddIcon from "@mui/icons-material/Add";

import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ReactNode, useState } from "react";
import Interval from "../../../../models/communications/Interval";
import IntervalSet from "../../../../models/communications/IntervalSet";
import InteractionNodeInterval from "../../../../models/interactions/InteractionNodeInterval";
import InteractionNode from "../../../../models/interactions/InteractionNode";
import Interaction from "../../../../models/interactions/Interaction";
import { useStoreDispatch } from "../../../../store/Hooks";
import IconButton from "@mui/material/IconButton";


interface MatrixControlsProps {
  intervalSetID: number;
  children?: ReactNode;
  associatedIntervals: Array<Interval>;
  associatedInteractionNodeIntervals: Array<InteractionNodeInterval>;
  associatedInteractionNodes: Array<InteractionNode>;
  associatedInteractions: Array<Interaction>;
  currentParent?: number | null;
  currentSet?: number | null;
  editMode: boolean;
  intervalSetName: string | null;
  parentHover?: boolean;
  align?: string | undefined;
  communicationSetID?: number | null | undefined;
  addNewIntervalToIntervalSet: any;
  inAccordionSummary?: boolean | undefined
}

const MatrixControls = (props: MatrixControlsProps) => {
  const dispatch = useStoreDispatch();

  const [anchorElIntervalControls, setAnchorElIntervalControls] =
    useState<null | HTMLElement>(null);
  const [anchorElInteractionControls, setAnchorElInteractionControls] =
    useState<null | HTMLElement>(null);

  const openIntervalControlsDropdown = Boolean(anchorElIntervalControls);
  const openInteractionControlsDropdown = Boolean(anchorElInteractionControls);

  const handleCloseIntervalControls = () => {
    setAnchorElIntervalControls(null);
  };
  const handleCloseInteractionControls = () => {
    setAnchorElInteractionControls(null);
  };

  const handleClickIntervalControls = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorElIntervalControls(event.currentTarget);
  };

  let align = "none";
  if (typeof props.align === "string") {
    align = props.align;
  }
  return (
    <span style={{ float: align }}>
      {/* show original add interval button if there's no intervals already in the new intervalSet */}

      <Tooltip title="Add new interval">
        <IconButton
          style={{ color: "#1976d2" , marginRight: props.inAccordionSummary ? "0px" : "-15px" , marginTop: props.inAccordionSummary ? "27px" : "0px"}}
          data-testid={
            "matrixNewIntervalButtonForIntervalSet" + props.intervalSetID
          }
          disabled={!props.editMode}
          onClick={function (e) {
            e.stopPropagation();
            handleCloseIntervalControls();
            props.addNewIntervalToIntervalSet(
              props.associatedInteractionNodes,
              props.intervalSetID,
              "New Interval Name",
              0,
              0,
              props.communicationSetID || null
            );
          }}
          // variant="contained"
          // color="primary"
          size="small"
          // style={{border:"1pt solid #1976d2", padding:"10px"}}
          // style={{position:"absolute", right:"-65px",top:15}}
        >
          <CalendarMonthIcon           style={{ marginLeft: "40px", color: props.editMode ? "#1976d2" : "lightgray" , fontSize:"14pt"}} />
          <AddIcon style={{ marginLeft: "-7px", color: props.editMode ? "#1976d2" : "lightgray" , marginTop: "-15px",fontSize:"14pt" }} />
        </IconButton>
      </Tooltip>
      {/* {props.associatedIntervals.length > 0 &&
        (props.editMode || !props.intervalSetName) &&
        props.parentHover && (
          <Tooltip title="Add new interval">
            <Button
              data-testid={
                "matrixNewIntervalButtonForIntervalSet" + props.intervalSetID
              }
              onClick={function (e) {
                handleClickIntervalControls(e);
              }}
              variant="contained"
              color="primary"
              aria-label="add to shopping cart"
              style={{ position: "absolute", right: "0px", top: 15 }}
            >
              <CalendarMonthIcon /><AddIcon/>
            </Button>
          </Tooltip>
        )} */}
    </span>
  );
};

export default MatrixControls;
